// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleParagraph_root__2QM08","dropcap":"ArticleParagraph_dropcap__3I841"};